var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruckwhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 24,
    viewBox: "0 0 38 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1114",
    "data-name": "Group 1114",
    transform: "translate(17 -3836)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1113",
    "data-name": "Group 1113",
    transform: "translate(-17 3836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M587.952,415.284c-.474.649-1.157.5-1.787.417-.41-.052-.522-.439-.581-.81a3.819,3.819,0,0,0-.614-1.566,4.435,4.435,0,0,0-4.681-1.79,4.079,4.079,0,0,0-3.279,3.392c-.127.644-.345.816-1.011.821-1.214.009-1.342-.117-1.342-1.319q0-6.932,0-13.863c0-.87.229-1.1,1.089-1.1,1.657,0,3.314.006,4.971,0a1.224,1.224,0,0,1,1.024.472q2.927,3.509,5.877,7a4.855,4.855,0,0,1,.333.512Zm-7.763-9c1.027,0,2.053-.006,3.08,0a.816.816,0,0,0,.861-.442.84.84,0,0,0-.22-.944q-1.469-1.739-2.92-3.493a1.068,1.068,0,0,0-.9-.418c-.989.012-1.979,0-2.969,0-.67,0-.953.276-.956.936q-.008,1.7,0,3.4c0,.667.281.947.942.95C578.136,406.283,579.163,406.279,580.19,406.279Z",
    transform: "translate(-549.952 -395.294)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M267.913,345.783H278.45c.777,0,1.02.24,1.02,1.013q0,9.213,0,18.426c0,.776-.239,1.013-1.019,1.013h-9.015c-.738,0-.92-.15-1.061-.887a4.279,4.279,0,0,0-5.326-3.311,4.014,4.014,0,0,0-3.27,3.48.768.768,0,0,1-.84.715c-.581.011-1.163.009-1.744,0-.619-.008-.9-.29-.9-.916q0-2.849,0-5.7,0-6.4,0-12.8c0-.8.241-1.035,1.042-1.036Z",
    transform: "translate(-256.297 -345.783)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M621.948,579.034a3.228,3.228,0,1,1,3.224-3.239A3.246,3.246,0,0,1,621.948,579.034Zm.935-3.207a.941.941,0,1,0-.959.923A.952.952,0,0,0,622.884,575.826Z",
    transform: "translate(-590.592 -555.034)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M321.529,575.8a3.225,3.225,0,1,1-3.245-3.217A3.24,3.24,0,0,1,321.529,575.8Zm-3.212.954a.941.941,0,1,0-.962-.922A.973.973,0,0,0,318.317,576.755Z",
    transform: "translate(-310.517 -555.039)",
    fill: "#ffffff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckwhite);
export default __webpack_public_path__ + "static/media/truckwhite.a19a33dc3e9b4f514506ae6febc30552.svg";
export { ForwardRef as ReactComponent };